export default __webpack_public_path__ + "static/media/ellipse_valeur.ae388349.svg";